<div class="productos-cemento-filtros">
  <div class="productos-cemento-filtro-buscar">
    <app-cbb-field
      label="Buscar"
      placeholder="Buscar por comuna, producto, publicación, SKU..."
      [clearable]="true"
      [ngModel]="store.searchTerm()"
      (ngModelChange)="onSearchTermChange($event)"
    ></app-cbb-field>
  </div>
  <div class="productos-cemento-filtro-acciones">
    <app-cbb-button
      label="Carga masiva"
      color="info"
      (action)="abrirModalCargaMasiva()"
      [disabled]="store.loading()"
    ></app-cbb-button>
    <app-cbb-button
      label="Crear producto"
      color="green"
      (action)="abrirCrear()"
      [disabled]="store.loading()"
    ></app-cbb-button>
  </div>
</div>

<div *ngIf="store.error()" class="alert alert-warning py-2" role="alert">{{ store.error() }}</div>

<app-admin-server-table
  [columns]="tableColumns"
  [rows]="store.items()"
  [loading]="store.loading()"
  [emptyMessage]="'No hay productos para mostrar.'"
  [ordering]="store.ordering()"
  [pagination]="paginationState"
  [summaryNoun]="'productos'"
  [rowTrackBy]="trackByItem"
  (orderingChange)="onOrderingChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-admin-server-table>

<ng-template #priceCellTpl let-row>
  {{ row.precioBruto != null ? (row.precioBruto | number : '1.0-2') : '—' }}
</ng-template>

<ng-template #actionsCellTpl let-row>
  <div class="d-flex gap-1 justify-content-center align-items-center">
    <app-cbb-table-action-icon
      variant="edit"
      label="Editar"
      [disabled]="store.loading()"
      (action)="abrirEditar(row)"
    ></app-cbb-table-action-icon>
    <app-cbb-table-action-icon
      variant="void"
      label="Anular"
      [disabled]="store.loading()"
      (action)="prepararEliminar(row)"
    ></app-cbb-table-action-icon>
  </div>
</ng-template>

<ng-template #cargaMasivaTpl>
  <app-productos-cemento-carga-masiva-modal
    (closeRequested)="cerrarCargaMasivaModal()"
    (uploadRequested)="subirExcelCargaMasiva($event)"
  ></app-productos-cemento-carga-masiva-modal>
</ng-template>

<ng-template #detalleTpl>
  <app-producto-cemento-detalle-modal
    [item]="selectedItem"
    [loading]="store.loading()"
    (closeRequested)="cerrarDetalle()"
    (saveRequested)="guardar($event)"
    (deleteRequested)="solicitarEliminar()"
  ></app-producto-cemento-detalle-modal>
</ng-template>

<ng-template #confirmGuardarTpl>
  <app-politicas-entrega-confirm-delete-modal
    [loading]="store.loading()"
    [title]="tituloConfirmarGuardar"
    [message]="mensajeConfirmarGuardar"
    [entityLabel]="'producto'"
    [confirmButtonLabel]="etiquetaConfirmarGuardar"
    [confirmColor]="'green'"
    (closeRequested)="cancelarGuardar()"
    (confirmRequested)="confirmarGuardar()"
  ></app-politicas-entrega-confirm-delete-modal>
</ng-template>

<ng-template #confirmDeleteTpl>
  <app-politicas-entrega-confirm-delete-modal
    [loading]="store.loading()"
    [title]="'Confirmar eliminación'"
    [message]="'¿Desea eliminar este producto? Esta acción no se puede deshacer.'"
    [entityLabel]="'producto'"
    [confirmButtonLabel]="'Confirmar eliminación'"
    [confirmColor]="'danger'"
    (closeRequested)="cancelarEliminar()"
    (confirmRequested)="confirmarEliminar()"
  ></app-politicas-entrega-confirm-delete-modal>
</ng-template>
